import { TransportMode } from '@shared/models/transportMode';
import styles from './DepartureOrArrivalTableChangedPlatformCell.module.scss';
import ImageIcon from './ImageIcon';
import { getPlatformName } from '@shared/utils/platformName';

interface DepartureOrArrivalTableChangedPlatformCellProps {
  type: 'departures' | 'arrivals';
  platform: string;
  transportMode: TransportMode;
  columnSpan: number;
  headerWidth?: number;
}

export default function DepartureOrArrivalTableChangedPlatformCell({
  type,
  platform,
  transportMode,
  columnSpan,
  headerWidth,
}: DepartureOrArrivalTableChangedPlatformCellProps) {
  const platformName = getPlatformName(transportMode);
  return (
    <td
      className={styles['changed-platform-cell']}
      colSpan={columnSpan}
      style={{ minWidth: headerWidth }}
    >
      <ImageIcon
        type="traffic-situation-normal"
        alt=""
        className={styles.icon}
      />{' '}
      <span className={styles.message}>
        {type == 'departures'
          ? `Avgår från ${platformName} ${platform}`
          : `Ankommer till ${platformName} ${platform}`}
      </span>
    </td>
  );
}
